import React, { Component } from 'react';

import Blocks from './parts/home/Blocks';
import ButtonChoose from '../components/ButtonChoose';
import Clients from '../components/Clients';
import ContactButton from '../components/contact/ContactButton';
import QuoteBar from '../components/QuoteBar';
import Slider from '../components/Slider';

import backgroundImage from '../resources/img/slider-bg-pic1.jpg';
import webbanner from '../resources/video/webbanner.mp4';

class Home extends Component {

    render() {
        document.title = 'TROI Studio';

        var textLeft = (
            <h2>
                TROI publishes digital content for<br />
                companies and universities.
            </h2>
        );

        var textRight = (
            <div style={{lineHeight: '50px'}}>
                <span>STRATEGY</span>
                <span>CONTENT</span>
                <span>TECHNOLOGY</span>
            </div>
        );

        var buttons = [
            {
                to: "universities",
                className: "btn-universities",
                text: "Universities"
            }, {
                to: "companies",
                className: "btn-companies",
                text: "Companies"
            }
        ];

        return (
            <div>
                <ContactButton />

                <Slider backgroundImage={backgroundImage}
                    textLeft={textLeft}
                    textRight={textRight}
                    video={webbanner}
                    buttons={buttons} />
                <QuoteBar text="" />

                <div className="clearfix" />

                <Blocks />

                <div className="visible-xs">
                    <ButtonChoose buttons={buttons} />
                </div>

                <Clients />
            </div>
       );
    }

}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home.js